import { UserStatusSchema, type UserStatus as GeneratedUserStatus } from '~/services/api/generated'

// Mirrors backend App\Enums\UserStatus

export type UserStatus = GeneratedUserStatus

export const UserStatus = {
  ACTIVE: UserStatusSchema.enum.active,
  INVITED: UserStatusSchema.enum.invited,
  INACTIVE: UserStatusSchema.enum.inactive
} satisfies Record<string, GeneratedUserStatus>

export const UserStatusValues: readonly GeneratedUserStatus[] = [
  UserStatusSchema.enum.active,
  UserStatusSchema.enum.invited,
  UserStatusSchema.enum.inactive
]
